import { Component, OnInit } from '@angular/core';
import {ApiService} from '../_services/api.service';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.css'],
    standalone: false
})
export class AdminComponent {
    openGroup: string | null = null;

    constructor(public apiService: ApiService) {
        this.apiService.admin_layout = true;
    }

    toggleGroup(group: string): void {
        this.openGroup = this.openGroup === group ? null : group;
    }

    isGroupOpen(group: string): boolean {
        return this.openGroup === group;
    }
}
